import React from "react";
import { Button, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { useAuth } from "duck";
import { UserRoleEnum } from "requests";
import { SelectionContext } from "../../../../duck";
import { Remove, Rename, CancelSelection } from "./components";

const Actions: React.FC = () => {
  const { selected } = React.useContext(SelectionContext);
  const [{ user }] = useAuth();
  const defaultSelected = selected.some(protocol => protocol.defaultProtocol);
  const isAdmin = user.userRole === UserRoleEnum.RoleOrganizationAdmin;

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        disabled={!selected.length || (defaultSelected && !isAdmin)}
        colorScheme="minor"
      >
        Actions
      </MenuButton>
      <MenuList p={2}>
        {selected.length === 1 && <Rename />}
        <Remove />
        <CancelSelection />
      </MenuList>
    </Menu>
  );
};

export default Actions;
